import { useEffect } from 'react';

import { SEGMENT_TAGS } from '@/analytics/tag-definitions';
import { PetProfileModel } from '@/generated-client/pet-profile-a';
import { useFeatureValue } from '@/hooks/useFeatureValue';
import { useAnalyticsContext } from '@/providers/AnalyticsProvider';
import { FeatureConfigKeys } from '@/utils/athena-feature-config';

import SignUpHeroSectionV1 from './SignUpHeroSectionV1/SignUpHeroSectionV1';
import SignUpHeroSectionV2 from './SignUpHeroSectionV2/SignUpHeroSectionV2';

export interface Props {
  petProfiles: PetProfileModel[];
  handleOpenConfirmationSheet: () => void;
}

export default function SignUpHeroSection({ petProfiles, handleOpenConfirmationSheet }: Props) {
  const signupV2Enabled = useFeatureValue(FeatureConfigKeys.SIGN_UP_PAGE_V2, false);

  const { trackSegmentEvent } = useAnalyticsContext();

  useEffect(() => {
    trackSegmentEvent(
      SEGMENT_TAGS.ViewsChewyPlusHeader.eventName,
      SEGMENT_TAGS.ViewsChewyPlusHeader.data,
    );
  }, [trackSegmentEvent]);

  return (
    <>
      {signupV2Enabled ? (
        <SignUpHeroSectionV2 petProfiles={petProfiles} />
      ) : (
        <SignUpHeroSectionV1
          handleOpenConfirmationSheet={handleOpenConfirmationSheet}
          petProfiles={petProfiles}
        />
      )}
    </>
  );
}
